import {
  ImportableFlowModel,
  ImportableFlowModelState
} from '@Client/runner.services/flow.model.import.service';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';
import { InfoIcon } from '@Shared.Angular/flowingly.components/InfoIcon/InfoIcon';
import React, { ChangeEvent, useState } from 'react';

type Props = {
  importable: ImportableFlowModel;
  index: number;
  maxCategoryDepth: number;
  disableSelection: boolean;
  updateParent: (
    index: number,
    propertyName: string,
    propertyValue: boolean
  ) => void;
};

const ImportableFlowModels = ({
  index,
  importable,
  maxCategoryDepth,
  disableSelection,
  updateParent
}: Props) => {
  const categoryExceedsDepth =
    importable.categoryHierarchy.length > maxCategoryDepth;
  const [importableFlowModel, setImportable] = useState(importable);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement>,
    targetProperty: string
  ) => {
    setImportable({
      ...importableFlowModel,
      [e.target.name]: e.target[targetProperty]
    });
    updateParent(index, e.target.name, e.target[targetProperty]);
  };

  return (
    <div className="importable-flow-model">
      <div className="details">
        <div className="category">
          <label>Category: </label>
          <span
            className={
              categoryExceedsDepth ? 'category-depth-exceeded' : undefined
            }
          >
            {importable.categoryHierarchy.map((cat) => cat.name).join(' / ')}
          </span>
        </div>
        <div className="category">
          <label>Name: </label>
          {importable.name}
        </div>
        {importable.existingFlowModelId && (
          <div className="name-clash">
            A Flow Model with this name already exists
            <InfoIcon message="Importing it again will overwrite the current Flow Model!" />
          </div>
        )}
        {importable.attachments?.length > 0 && (
          <div>{importable.attachments.length} attachments</div>
        )}
      </div>
      {importable.state === ImportableFlowModelState.Pending && (
        <div className="import-option">
          <input
            type="checkbox"
            name="willImport"
            data-testid="import-flow-model-checkbox"
            checked={importable.willImport}
            disabled={
              disableSelection ||
              !!importable.existingFlowModelId ||
              categoryExceedsDepth
            }
            onChange={(e) => handleChange(e, 'checked')}
            id={'import-flow-model-' + index}
          ></input>
          <label htmlFor={'import-flow-model-' + index}>Import</label>
        </div>
      )}
      {importable.state === ImportableFlowModelState.Success && (
        <Chip name="Imported" color="0B0" />
      )}
      {importable.state === ImportableFlowModelState.Failure && (
        <Chip name="Failed" color="B00" title={importable.importMessage} />
      )}
    </div>
  );
};

export default ImportableFlowModels;
